import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import VerifyCodeBtn from '../components/verifyCodeBtn';
import ErrorModal from '../components/errorModal';
import styles from '../styles/Home.module.scss';
import API from '../services/api';
import store from 'store-js';
import Loading from 'react-loading';
import { checkPwd } from '../utilities/Utils';
import { isIOS, isChrome } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { addStyle } from '../utilities/Utils';
import { useCookieState } from 'ahooks';

const location = '852';
const api = new API();

/* Dummy Code Testing */
const test_ac = ['12345678'];
const test_pwd = 'Demo1234';

export default function Home({ config }) {
    const CustomConfig = config.home_setting;
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [token, setToken] = useCookieState('access_token', { secure: true, sameSite: 'strict' });

    /*** OTP ***/
    const [locationCode, setLocationCode] = useState(location);
    const [phoneNum, setPhoneNum] = useState(null);
    const [verifyCode, setVerifyCode] = useState(null);

    const [invalidPhoneLength, setInvalidPhoneLength] = useState(true);
    const [invalidVerifyLength, setInvalidVerifyLength] = useState(true);

    const [invalidPhone, setInvalidPhone] = useState(false);
    const [invalidLocation, setInvalidLocation] = useState(false);

    const [isOTPloading, setIsOTPloading] = useState(false);

    /*** Username/ Email & Password ***/
    const [username, setUsername] = useState(null);
    const [pwd, setPwd] = useState(null);
    const [showPwd, setShowPwd] = useState(false);

    const [invalidUsernameEmail, setInvalidUsernameEmail] = useState(false);
    const [invalidPwd, setInvalidPwd] = useState(false);
    const [showInvalidText, setShowInvalidText] = useState(false);

    const [loginDisabled, setLoginDisabled] = useState(true);
    const [loginClicked, setLoginClicked] = useState(false);
    const [isLoginLoading, setIsLoginLoading] = useState(false);

    const [errModalMsg, setErrModalMsg] = useState(null);
    const [consoleMsg, setConsoleMsg] = useState(null);

    const [count, setCount] = useState(0);
    const [timeoutID, setTimeoutID] = useState(null);

    useEffect(() => {
        addStyle(`
      :root {
          --color-theme: ${config.theme.color}
      }`);

        // Popup msg for iOS
        isIOS && isChrome ? setErrModalMsg('warnBrowser') : setErrModalMsg(null);

        if (!token) store.clearAll();

        // Clear localStorage when tab is closed but not on refresh
        let session = sessionStorage.getItem('sessionReference');
        if (session == null) {
            let keys = [
                'owner_customer_id',
                'access_token',
                'coupons',
                'scannedQRcode',
                'merchant_id',
                'shopname',
                'address',
                'username'
            ];
            keys.forEach((key) => store.remove(key));
        }
        // console.log("Last update::: 18 Jan 2021");

        // Check if the page is refreshed & getOTP was clicked
        // if (session) {
        //   if (store.get("otpCountDown")) {
        //     setCount(Number(store.get("otpCountDown")));
        //   }
        // }

        // return () => {
        //   clearTimeout(window.otpTimeoutID);
        // };
    }, []);

    useEffect(() => {
        // if (!invalidPhoneLength && !invalidVerifyLength) {
        if (!invalidPhoneLength && pwd !== null && !invalidPwd) {
            document.getElementsByClassName('colorBtn')[0].disabled = false;
            setLoginDisabled(false);
            // } else if (invalidPhoneLength || invalidVerifyLength) {
        } else if (invalidPhoneLength || invalidPwd) {
            document.getElementsByClassName('colorBtn')[0].disabled = true;
            setLoginDisabled(true);
        }
    }, [invalidPhoneLength, pwd, invalidPwd]);

    useEffect(() => {
        // console.log(locationCode);
        if (phoneNum) validateLocPhone(phoneNum);
    }, [locationCode]);

    useEffect(() => {
        if (pwd) {
            let valid = checkPwd(pwd);
            if (valid) {
                setInvalidPwd(false);
                setShowInvalidText(false);
            } else {
                setInvalidPwd(true);
                setShowInvalidText(true);
            }
        } else setInvalidPwd(true);
    }, [pwd]);

    useEffect(() => {
        if (loginClicked) {
            /* Dummy Code Testing */
            // vvv For Password Rest Testing vvv
            // let correctPwd = store.get("newPwd") ? store.get("newPwd") : test_pwd;
            // if (test_ac.includes(phoneNum) && pwd === correctPwd) {
            //   store.set("access_token", "res.payload.access_token");
            //   setTimeout(() => {
            //     return navigate("/userhome");
            //   }, 1000);
            // } else {
            //   setShowInvalidText(true);
            //   setIsLoginLoading(false);
            //   setLoginClicked(false);
            // }
            ///////////////////////////////////////////////////////////////

            api
                // .getAccessToken(locationCode, phoneNum, verifyCode)
                .getAccessToken(locationCode, phoneNum, pwd)
                .then((res) => {
                    if (res && res.response.code === '200') {
                        // clearTimeout(window.otpTimeoutID);
                        // store.removeItem("otpCountDown");
                        setToken(res.payload.access_token);
                        return navigate('/userhome');
                    } else if (res.response.code === '400') {
                        switch (res.payload?.error_code) {
                            case '4202':
                                setErrModalMsg(t('home_pwd_invalid_username_pwd_msg'));
                                break;
                            case '4203':
                                setErrModalMsg(t('errMsg_ac_locked'));
                                break;
                            case '4290':
                                setErrModalMsg(t('errMsg_rate_limit_exceeded'));
                                break;
                            case '4523':
                                setErrModalMsg(t('errMsg_inactiveUser'));
                                break;
                            case '4531':
                                setErrModalMsg(t('errMsg_inactiveStore'));
                                break;
                            default:
                                setErrModalMsg('發生錯誤（E1）');
                                // setConsoleMsg(2);
                                break;
                        }
                    }
                })
                .catch((err) => {
                    setConsoleMsg(t('errMsg_networkErr'));
                    console.log(err);
                })
                .finally(() => {
                    setIsLoginLoading(false);
                    setLoginClicked(false);
                });
        }
    }, [loginClicked]);

    // Verification code count down
    // useEffect(() => {
    //   if (count !== 0) {
    //     store.set("otpCountDown", count);
    //     updateTimeoutId();
    //   } else {
    //     clearTimeout(window.otpTimeoutID);
    //     return store.removeItem("otpCountDown");
    //   }
    // }, [count]);

    // const updateTimeoutId = () => {
    //   let newTimeoutID = setTimeout(() => {
    //     setCount(count - 1);
    //   }, 1000);
    //   window.otpTimeoutID = newTimeoutID;
    //   setTimeoutID(window.otpTimeoutID);
    // };

    const handleLocationCode = (e) => {
        setLocationCode(e.target.value);
    };

    const handlePhoneNum = (e) => {
        let value = e.target.value;
        setPhoneNum(e.target.value);
        validateLocPhone(value);
    };

    const validateLocPhone = (value) => {
        if (locationCode === '852') {
            if (value.length === 8 && !/\D/.test(value)) {
                setInvalidPhoneLength(false);
            } else {
                setInvalidPhoneLength(true);
            }
        } else if (locationCode === '86') {
            if (value.length === 11 && !/\D/.test(value)) {
                setInvalidPhoneLength(false);
            } else {
                setInvalidPhoneLength(true);
            }
        }
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleVerify = (e) => {
        if (e.target.value.length > 0) {
            setVerifyCode(e.target.value);
            setInvalidVerifyLength(false);
        } else setInvalidVerifyLength(true);
    };

    // Fetch getVerificationCode
    const handleGetCode = () => {
        if (invalidPhoneLength) {
            setInvalidLocation(true);
            setInvalidPhone(true);
            return setErrModalMsg('格式錯誤');
        }

        setIsOTPloading(true);

        api.getVerificationCode(locationCode, phoneNum)
            .then((res) => {
                if (res && res.response.code === '200') {
                    setInvalidLocation(false);
                    setInvalidPhone(false);
                    setIsOTPloading(false);
                    setCount(180);
                    // on refresh still countinue countdown
                    window.sessionStorage.set('sessionReference', 1);
                } else if (res.response.code === '400') {
                    setInvalidLocation(true);
                    setInvalidPhone(true);
                    if (
                        res.response.message === '輸入電話不正確' ||
                        res.response.message === '區號和電話只能輸入數字'
                    ) {
                        return setErrModalMsg('格式錯誤');
                    } else if (res.response.message.includes('已被封鎖') || res.response.message.includes('停用')) {
                        return setErrModalMsg('ac_locked');
                    } else {
                        setConsoleMsg(res.response.message);
                        console.log(res.response.message, res.response.payload);
                    }
                }
            })
            .catch((err) => {
                setConsoleMsg(t('errMsg_networkErr'));
                console.log(err);
            })
            .finally(() => {
                setIsOTPloading(false);
            });
    };

    const handlePassword = (e) => {
        let value = e.target.value;
        setPwd(value);
    };

    const handleLogin = () => {
        setIsLoginLoading(true);
        setLoginClicked(true);
    };

    const handleCloseErrModal = () => {
        setErrModalMsg(null);
        setConsoleMsg(null);
    };

    return (
        <>
            <div className="content noselect">
                <img src={CustomConfig.logo_src} alt="banner" style={{ width: '100vw' }} />
                <div className="marginContent">
                    <div className="mallName">
                        <h2>{t('home_heading')}</h2>
                    </div>
                    <label style={{ alignItems: 'left' }}>{t('home_phone_input_label')}</label>
                    <FormControl className={styles.form}>
                        <NativeSelect
                            value={locationCode}
                            onChange={(e) => handleLocationCode(e)}
                            name="locationCode"
                            className={styles.locationCode}
                            style={{
                                borderBottom: invalidLocation ? '1.5px solid #f44336' : 'initial'
                            }}
                        >
                            <option value={852}>852</option>
                            <option value={86}>86</option>
                        </NativeSelect>
                        {/* <Input
                            disabled
                            className={styles.locationCode}
                            style={{
                                width: '50px'
                            }}
                            defaultValue="+ 852"
                        /> */}
                        <TextField
                            variant="standard"
                            type="tel"
                            inputMode="tel"
                            className={styles.fullTextLength}
                            placeholder={t('home_phone_input_placeholder')}
                            error={invalidPhone}
                            onChange={(e) => handlePhoneNum(e)}
                            value={phoneNum}
                        />
                    </FormControl>

                    <label>{t('home_pwd_input_label')}</label>
                    <Input
                        type={showPwd ? 'text' : 'password'}
                        className={styles.fullTextLength}
                        placeholder={t('home_pwd_input_placeholder')}
                        onChange={(e) => handlePassword(e)}
                        value={pwd}
                        style={{
                            width: '100%',
                            borderBottom: showInvalidText ? '#D46666' : '#cacaca'
                        }}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => setShowPwd(!showPwd)}
                                    onMouseDown={handleMouseDownPassword}
                                >
                                    {showPwd ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                    {showInvalidText && (
                        <p
                            style={{
                                fontSize: '14px',
                                marginBottom: '-10px',
                                color: '#e11111'
                            }}
                        >
                            {t('home_pwd_invalid_username_pwd_msg')}
                        </p>
                    )}
                    {/* OTP Login */}
                    {/* <FormControl className={`${styles.form} ${styles.verfiyForm}`}>
                        <TextField
                            type="number"
                            className={styles.fullTextLength}
                            placeholder="6位數字驗證碼"
                            onChange={(e) => handleVerify(e)}
                            style={{
                                width: '100%',
                                borderBottom: showInvalidText ? '#D46666' : '#cacaca'
                            }}
                        />
                        <VerifyCodeBtn
                            page="home"
                            handleGetCode={handleGetCode}
                            count={count}
                            otpLoading={isOTPloading}
                            config={config}
                        />
                    </FormControl> */}
                    <div style={{ display: 'flex', alignItems: 'baseline' }}>
                        <p
                            style={{
                                fontSize: '14px',
                                // marginTop: "5px",
                                marginTop: '-10px',
                                color: showInvalidText ? '#e11111' : '#999999'
                            }}
                        >
                            {t('home_pwd_hints')}
                        </p>
                        <p
                            className="textBtn theme"
                            style={{ textDecoration: 'underline', marginLeft: '10px' }}
                            onClick={() => navigate('/forget_password')}
                        >
                            {t('home_forgetPwd_btn_label')}
                        </p>
                    </div>
                    <button
                        className="colorBtn fetch"
                        disabled={loginDisabled}
                        style={{
                            backgroundColor: loginDisabled ? '#888888' : config.theme.color
                        }}
                        onClick={handleLogin}
                    >
                        {isLoginLoading ? <Loading color={'#ffffff'} /> : `${t('home_heading')}`}
                    </button>
                    <button
                        className="whiteBtn"
                        style={{ marginTop: '0' }}
                        onClick={() => navigate('/forget_password')}
                    >
                        {t('forgetPwd_title').split(' ')[0]}
                    </button>
                </div>
            </div>
            <ErrorModal
                openModal={errModalMsg || consoleMsg ? true : false}
                errorMsg={errModalMsg}
                consoleMsg={consoleMsg}
                handleCloseModal={handleCloseErrModal}
                t={t}
                config={config}
            />
        </>
    );
}
